import { render, staticRenderFns } from "./FormularioUsuarioComponent.vue?vue&type=template&id=2e137dfb"
import script from "./FormularioUsuarioComponent.vue?vue&type=script&lang=js"
export * from "./FormularioUsuarioComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports